<template>
  <document-list :config="config" :isLoading="isLoading" :height="height"></document-list>
</template>

<script>
import DocumentList from './DocumentList';
import loaderMixin from '@/mixins/loaderMixin';
export default {
  mixins: [loaderMixin],
  name: 'ConfigurableDocumentList',

  props: {
    config: Object,
    height: Number, // optional height of this widget
  },
  created() {
    this.config.userModuleSelectionEnabled = true;
    this.config.userFolderSelectionEnabled = true;
    this.config.userAcknowledgeSelectionEnabled = true;
    this.config.userUnreadOnlySelectionEnabled = true;
    this.config.userFavoritesSelectionEnabled = true;
  },
  components: {
    DocumentList,
  },
};
</script>
